import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import classes from './FaceToFaceConsultingRoom.module.css';
import {
  selectConsultationFindingStatus,
  selectConsultationFindings,
  ConsultationFinding,
} from '../../store/slices/consultationFindings';
import {
  selectConsultationInvestigationStatus,
  selectConsultationInvestigations,
  ConsultationInvestigation,
} from '../../store/slices/consultationInvestigations';
import {
  selectConsultationRecommendationStatus,
  selectConsultationRecommendations,
  ConsultationRecommendation,
} from '../../store/slices/consultationRecommendations';
import {
  resetUpdateSalesOrderAppointmentStatus,
  selectSalesOrderAppointmentUpdateStatus,
} from '../../store/slices/salesOrders';
import {
  IWorkOrderService,
  selectCreatedWorkOrderService,
  updateStatusOfConsultation,
  selectConsultationStatusUpdateStatus,
  resetUpdateStatus,
} from '../../store/slices/workOrderServiceConsultation';
import { useAppDispatch, useAppSelector } from '../../store/store';
import ConfirmationModal from '../../components/UI/Modals/ConfirmationModal';

import { selectMerchantPersonId, selectUserLocation } from '../../store/slices/auth';
import { IDoctor, selectDoctors } from '../../store/slices/doctors';
import { useTranslation } from '../../hooks/useTranslations';

const FaceToFaceConsultingRoom: React.FC<any> = () => {
  const { translations } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userLocation: string = useAppSelector<string>(selectUserLocation);
  const location = useLocation();
  const [pageInfo] = useState<any>(location.state);
  const [findingsText, setFindingsText] = useState<string>('');
  const [investigationText, setInvestigationText] = useState<string>('');
  const [recommendationText, setRecommendationText] = useState<string>('');
  const [isFinalizeModalOpen, setIsFinalizeModalOpen] = useState<boolean>(false);
  const [isParkModalOpen, setIsParkModalOpen] = useState<boolean>(false);
  const consultationFindingsStatus: string = useAppSelector<string>(
    selectConsultationFindingStatus
  );
  const consultationFindings: ConsultationFinding[] = useAppSelector<ConsultationFinding[]>(
    selectConsultationFindings
  );
  const consultationInvestigationsStatus: string = useAppSelector<string>(
    selectConsultationInvestigationStatus
  );
  const consultationInvestigations: ConsultationInvestigation[] = useAppSelector<
    ConsultationInvestigation[]
  >(selectConsultationInvestigations);
  const consultationRecommendationsStatus: string = useAppSelector<string>(
    selectConsultationRecommendationStatus
  );
  const consultationRecommendations: ConsultationRecommendation[] = useAppSelector<
    ConsultationRecommendation[]
  >(selectConsultationRecommendations);
  const createdWorkOrderService: IWorkOrderService | null =
    useAppSelector<IWorkOrderService | null>(selectCreatedWorkOrderService);
  const salesOrderAppointmentUpdateStatus: string = useAppSelector<string>(
    selectSalesOrderAppointmentUpdateStatus
  );
  const consultationStatusUpdateStatus: string = useAppSelector<string>(
    selectConsultationStatusUpdateStatus
  );
  const merchantPersonId = useAppSelector<string>(selectMerchantPersonId);
  const doctors: IDoctor[] = useAppSelector<IDoctor[]>(selectDoctors);

  const doctorAssigned = doctors.find((doctor) =>
    doctor.person_appointments.find(
      (appointment) =>
        appointment.sales_order_id == pageInfo?.sales_order?.sales_order_id &&
        appointment.sales_order_item_id == pageInfo?.sales_order_item?.sales_order_item_id
    )
  );

  useEffect(() => {
    if (
      salesOrderAppointmentUpdateStatus === 'fulfilled' ||
      salesOrderAppointmentUpdateStatus === 'rejected'
    ) {
      dispatch(resetUpdateSalesOrderAppointmentStatus());
      setIsFinalizeModalOpen(false);
      if (salesOrderAppointmentUpdateStatus === 'fulfilled') {
        navigate('/web/schedule');
      }
    }
  }, [salesOrderAppointmentUpdateStatus]);

  useEffect(() => {
    if (consultationStatusUpdateStatus === 'fulfilled') {
      dispatch(resetUpdateStatus());
      setIsFinalizeModalOpen(false);
      setIsParkModalOpen(false);
      navigate('/web/schedule');
    }
    if (consultationStatusUpdateStatus === 'rejected') {
      dispatch(resetUpdateStatus());
    }
  }, [consultationStatusUpdateStatus, dispatch]);

  useEffect(() => {
    if (consultationFindingsStatus === 'fulfilled') {
      setFindingsText(
        consultationFindings.find(
          (cf) => cf.consultation_findings_id === createdWorkOrderService?.consultation_findings_id
        )?.consultation_findings_description ?? ''
      );
    }
  }, [consultationFindingsStatus]);

  useEffect(() => {
    if (consultationInvestigationsStatus === 'fulfilled') {
      setInvestigationText(
        consultationInvestigations.find(
          (ci) =>
            ci.consultation_investigations_id ===
            createdWorkOrderService?.consultation_investigations_id
        )?.consultation_investigations_description ?? ''
      );
    }
  }, [consultationInvestigationsStatus]);

  useEffect(() => {
    if (consultationRecommendationsStatus === 'fulfilled') {
      setRecommendationText(
        consultationRecommendations.find(
          (cr) =>
            cr.consultation_recommendations_id ===
            createdWorkOrderService?.consultation_recommendations_id
        )?.consultation_recommendations_description ?? ''
      );
    }
  }, [consultationRecommendationsStatus]);

  return (
    <div className={`${classes.container} ${classes.containerWithDetails}`}>
      <div className={classes.menuContainer}>
        {/* <VideoMenu
          handleClose={() => setShowFinalizeSection(true)}
          findingText={findingsText}
          findingId={finding?.consultation_findings_id ?? 0}
          recommendationText={recommendationText}
          recommendationId={recommendation?.consultation_recommendations_id ?? 0}
          internalNoteText={internalNotesText}
          internalNoteId={internalNotes?.consultation_notes_id ?? 0}
          variant="full"
          workOrderStatusId={6}
          actionButton={
            <>
              {!isFinalizing ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <PrimaryButtonV2
                    text={translations('finalize.consultation').toString()}
                    containerStyle={{
                      marginRight: '10px',
                    }}
                    buttonStyle={{
                      height: '46px',
                      width: '240px',
                    }}
                    disabled={false}
                    onClick={() => setIsFinalizeModalOpen(true)}
                  />
                  <PrimaryButtonV2
                    text={translations('park.consultation').toString()}
                    containerStyle={{}}
                    buttonStyle={{
                      height: '46px',
                      width: '240px',
                    }}
                    disabled={false}
                    onClick={() => setIsParkModalOpen(true)}
                  />
                </div>
              ) : (
                <Spinner />
              )}
            </>
          }
        /> */}
      </div>
      {(isFinalizeModalOpen || isParkModalOpen) && (
        <ConfirmationModal
          isOpen={isFinalizeModalOpen || isParkModalOpen}
          onClose={() => {
            setIsFinalizeModalOpen(false);
            setIsParkModalOpen(false);
          }}
          onConfirm={() => {
            dispatch(
              updateStatusOfConsultation({
                workOrderId: createdWorkOrderService?.work_order_id ?? 0,
                // 2 is for Closed, 4 is for Parked
                workOrderStatusId: isFinalizeModalOpen ? 2 : 4,
                details: {
                  online_consultation_result: {
                    doctor_name: doctorAssigned
                      ? `${doctorAssigned.person_firstname} ${doctorAssigned.person_lastname}`
                      : userLocation,
                    findings: findingsText,
                    investigation: investigationText,
                    recommandation: recommendationText,
                  },
                },
                taId: pageInfo?.sales_order.ta_id,
                transactionId: pageInfo?.sales_order.transaction_id,
                salesOrderId: pageInfo?.sales_order.sales_order_id,
                salesOrderExternalId: pageInfo?.sales_order.sales_order_external_id,
                externalSalesOrderItemId: pageInfo?.sales_order_item?.external_sales_order_item_id,
                personEmail: pageInfo?.person.person_email,
                personAccountNumber: pageInfo?.person.person_account_number,
                merchantPersonId: merchantPersonId,
                doctor: doctorAssigned
                  ? `${doctorAssigned.person_firstname} ${doctorAssigned.person_lastname}`
                  : undefined,
                isFaceToFace: true,
              })
            );
            setIsFinalizeModalOpen(false);
            setIsParkModalOpen(false);
          }}
          apiStatus={salesOrderAppointmentUpdateStatus}
          title={translations('are.you.sure')}
          body={
            isFinalizeModalOpen
              ? translations('placeholder.body').toString()
              : translations('placeholder.body.parked').toString()
          }
        />
      )}
    </div>
  );
};

export default FaceToFaceConsultingRoom;
